import React, { useContext, useState } from "react";
import "./StartupProjects.scss";
import { bigProjects } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import ComponentModal from "../../components/achievementCard/ComponentModal.js";

export default function StartupProject() {
  const { isDark } = useContext(StyleContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [CurrentComponent, setCurrentComponent] = useState(null);

  if (!bigProjects.display) return null;

  const handleOpenModal = (Component) => {
    setCurrentComponent(() => Component);
    setModalOpen(true);
  };
  const handleCloseModal = () => {
    setModalOpen(false);
    setCurrentComponent(null);
  };
  const openUrlInNewTab = (url) => {
    if (!url) return;
    const win = window.open(url, "_blank");
    win.focus();
  };

  // Renders an array of <p> tags, un-escaping any HTML inside desc
  const renderDescs = (descs) =>
    descs.map((desc, idx) => (
      <p
        key={idx}
        className="project-desc-text"
        dangerouslySetInnerHTML={{ __html: desc }}
      />
    ));

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="projects">
        <h1 className="skills-heading">{bigProjects.title}</h1>
        <p className={isDark ? "dark-mode project-subtitle" : "subTitle project-subtitle"}>
          {bigProjects.subtitle}
        </p>
        <div className="projects-container">
          {bigProjects.projects.map((project, i) => {
            // this version is used inside your modal
            const ProjectComponent = () => (
              <div>
                <div className="project-image">
                  <a href={project.footerLink[0].url} target="_blank" rel="noreferrer">
                    <img
                      src={project.image}
                      alt={project.projectName}
                      className="card-image"
                    />
                  </a>
                </div>
                <div className="project-detail">
                  <h5 className={isDark ? "dark-mode card-title" : "card-title"}>
                    {project.projectName}
                  </h5>
                  <div className="project-description">
                    {renderDescs(project.projectDescs)}
                    {project.additionalImage && (
                      <img
                        src={project.additionalImage}
                        alt={project.projectName + " additional"}
                        className="additional-image right-align"
                      />
                    )}
                  </div>
                </div>
                {project.footerLink && (
                  <div className="project-card-footer">
                    {project.footerLink.map((link, idx2) => (
                      <span
                        key={idx2}
                        className={isDark ? "dark-mode project-tag" : "project-tag"}
                        onClick={() => openUrlInNewTab(link.url)}
                      >
                        {link.name}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            );

            // the card itself
            return (
              <div
                key={i}
                className={
                  isDark
                    ? "dark-mode project-card project-card-dark"
                    : "project-card project-card-light"
                }
                onClick={() => handleOpenModal(ProjectComponent)}
              >
                <div className="project-image">
                  <a href={project.footerLink[0].url} target="_blank" rel="noreferrer">
                    <img
                      src={project.image}
                      alt={project.projectName}
                      className="card-image"
                    />
                  </a>
                </div>
                <div className="project-detail">
                  <h5 className={isDark ? "dark-mode card-title" : "card-title"}>
                    {project.projectName}
                  </h5>
                  <div className="project-description">
                    {renderDescs(project.projectDescs)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <ComponentModal
        open={modalOpen}
        handleClose={handleCloseModal}
        Component={CurrentComponent}
      />
    </Fade>
  );
}
